<!--
 * @Description: 计划管理日志
 * @Author: Tina
 * @Date: 2022-12-16 10:32:21
 * @LastEditors: Tina
 * @LastEditTime: 2023-01-29 10:14:50
 -->

<template>
  <div class="sale-plan" @keyup.enter="enterSearch">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="70px">
      <el-form-item label="模板名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入模板名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light">
      <el-table-column
        prop="name"
        label="模板名称"
        width="200"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="修改内容"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        width="200"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="updatePerson"
        label="修改人"
        width="200"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <el-pagination
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'salePlanManageHistory',
  data () {
    return {
      form: {
        name: ''
      }
    }
  },
  computed: {
    ...mapGetters({ list: 'getSalePlanManageHistoryList', listState: 'getSalePlanManageHistoryListState' })
  },
  methods: {
    ...mapActions(['getSalePlanManageHistoryList']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1 }
      this.getSalePlanManageHistoryList(params)
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getSalePlanManageHistoryList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getSalePlanManageHistoryList({ pageNo: val })
    },
    formatStatus (row) {
      const status = this.$lodash.find(this.statusArr, { value: row.status }) || {}
      return status.label
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style scoped>

</style>
